import { Modal } from 'antd';
import './SuccessConfirmModal.css';

const showSuccessConfirmModal = ({ title, content, okText, cancelText, className, onOk }) => {
  Modal.confirm({
    title,
    icon: null,
    content,
    okText,
    okType: 'primary',
    cancelText,
    className: `${className} success-modal`,
    onOk,
    okButtonProps: { 
      style: { 
        backgroundColor: '#52c41a', 
        borderColor: '#52c41a',
        color: 'white'
      } 
    },
  });
};

export default showSuccessConfirmModal;
